(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function initPdpScrollReveals(rootEl) {
    if (!rootEl) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      rootEl.querySelectorAll(".pdp-reveal, .pdp-reveal-group").forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.14, rootMargin: "0px 0px -7% 0px" }
    );
    rootEl.querySelectorAll(".pdp-reveal-group, .pdp-reveal").forEach(function (el) {
      if (el.classList.contains("pdp-reveal") && el.closest(".pdp-reveal-group")) return;
      revealObserver.observe(el);
    });
  }

  ready(function () {
    var root = document.querySelector(".pdp[data-product-pdp]");
    if (!root) return;

    initPdpScrollReveals(root);

    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    var variants = [];
    var priceMap = {};
    var mediaMap = {};

    try {
      var jv = document.getElementById("pdp-variants-json");
      if (jv && jv.textContent) variants = JSON.parse(jv.textContent);
    } catch (e) {}

    try {
      var jp = document.getElementById("pdp-price-map");
      if (jp && jp.textContent) priceMap = JSON.parse(jp.textContent);
    } catch (e) {}

    try {
      var jm = document.getElementById("pdp-variant-media");
      if (jm && jm.textContent) mediaMap = JSON.parse(jm.textContent);
    } catch (e) {}

    var bundleCartMap = {};
    try {
      var jbc = document.getElementById("pdp-bundle-cart-variants");
      if (jbc && jbc.textContent) bundleCartMap = JSON.parse(jbc.textContent);
    } catch (e3) {}

    var priceEl = root.querySelector("[data-pdp-price-main]");
    var compareEl = root.querySelector("[data-pdp-compare-main]");
    var saveEl = root.querySelector("[data-pdp-save-main]");
    var bundleSaveEl = root.querySelector("[data-pdp-bundle-save-main]");
    var soldRow = root.querySelector("[data-pdp-sold-row]");
    var stickyPrice = root.querySelector("[data-pdp-sticky-price]");
    var stickyBar = root.querySelector(".pdp-sticky");
    var submitBtns = root.querySelectorAll('button[name="add"], [data-bundle-desktop-atc]');

    function findVariantInList(sel, list, loose) {
      var L = list || variants;
      return L.find(function (v) {
        if (!loose) {
          if (sel.length >= 1 && (v.option1 || "") !== (sel[0] || "")) return false;
          if (sel.length >= 2 && (v.option2 || "") !== (sel[1] || "")) return false;
          if (sel.length >= 3 && (v.option3 || "") !== (sel[2] || "")) return false;
          return true;
        }
        for (var i = 0; i < 3; i++) {
          var vVal = i === 0 ? v.option1 : i === 1 ? v.option2 : v.option3;
          vVal = vVal == null ? "" : String(vVal);
          var sVal = i < sel.length && sel[i] != null ? String(sel[i]) : "";
          if (vVal.length > 0 && vVal !== sVal) return false;
        }
        return true;
      });
    }

    function findVariant(sel) {
      return findVariantInList(sel, variants, false);
    }

    function variantsForBundleRadio(radio) {
      if (!radio) return variants;
      var ds = radio.dataset ? radio.dataset.cartVariants : null;
      if (ds) {
        try {
          var parsed = JSON.parse(ds);
          if (Array.isArray(parsed) && parsed.length) return parsed;
        } catch (e4) {}
      }
      if (bundleCartMap && typeof bundleCartMap === "object") {
        var alt = bundleCartMap[String(radio.value)];
        if (alt && Array.isArray(alt) && alt.length) return alt;
      }
      return variants;
    }

    function getSelectedFromButtons() {
      var groups = root.querySelectorAll(".pdp__option-group");
      var max = -1;
      groups.forEach(function (group) {
        var idx = parseInt(group.getAttribute("data-option-index"), 10);
        if (idx > max) max = idx;
      });
      var sel = [];
      for (var i = 0; i <= max; i++) {
        var group = root.querySelector('.pdp__option-group[data-option-index="' + i + '"]');
        var btn = group ? group.querySelector(".pdp__opt.is-selected") : null;
        sel.push(btn ? btn.getAttribute("data-value") || "" : "");
      }
      return sel;
    }

    function getSelectedFromButtonsInCard(card) {
      if (!card) return [];
      var groups = card.querySelectorAll(".pdp__option-group");
      var max = -1;
      groups.forEach(function (group) {
        var idx = parseInt(group.getAttribute("data-option-index"), 10);
        if (!isNaN(idx) && idx > max) max = idx;
      });
      var sel = [];
      for (var i = 0; i <= max; i++) {
        var group = card.querySelector('.pdp__option-group[data-option-index="' + i + '"]');
        var btn = group ? group.querySelector(".pdp__opt.is-selected:not(.pdp__opt--bundle-extra)") : null;
        sel.push(btn ? btn.getAttribute("data-value") || "" : "");
      }
      return sel;
    }

    function readBundleDiscountCode(radio) {
      if (!radio) return "";
      var a = typeof radio.getAttribute === "function" ? radio.getAttribute("data-bundle-discount") : null;
      var d = radio.dataset && radio.dataset.bundleDiscount;
      var raw = (a != null && String(a).length ? a : d) || "";
      return String(raw).trim();
    }

    function cartAddJsPath(form) {
      var action = form.getAttribute("action") || "/cart/add";
      try {
        var u = new URL(action, window.location.href);
        u.pathname = u.pathname.replace(/\/cart\/add\/?$/, "/cart/add.js");
        return u.pathname + u.search;
      } catch (e) {
        return "/cart/add.js";
      }
    }

    function getVariantForBundleSlot(card, slot, baseSel, cartVariants) {
      var V = cartVariants || variants;
      var loose = V !== variants;
      if (slot === 1) {
        return findVariantInList(baseSel, V, loose);
      }
      var g = card.querySelector('.pdp__bundle-extra-group[data-bundle-slot="' + slot + '"]');
      if (!g) return null;
      var btn = g.querySelector(".pdp__opt--bundle-extra.is-selected");
      if (!btn) return null;
      var rawOi = btn.getAttribute("data-option-index");
      var oi = rawOi !== null && rawOi !== "" ? parseInt(rawOi, 10) : 0;
      if (isNaN(oi) || oi < 0) oi = 0;
      var val = btn.getAttribute("data-value") || "";
      var sel = baseSel.slice();
      while (sel.length <= oi) sel.push("");
      sel[oi] = val;
      return findVariantInList(sel, V, loose);
    }

    function isMobilePdp() {
      return window.matchMedia("(max-width: 900px)").matches;
    }

    function syncPdpStickyBottom() {
      if (!stickyBar || !window.visualViewport) return;
      if (!isMobilePdp()) {
        stickyBar.style.bottom = "";
        return;
      }
      var vv = window.visualViewport;
      var inset = window.innerHeight - vv.height - vv.offsetTop;
      if (inset < 0) inset = 0;
      stickyBar.style.bottom = Math.round(inset) + "px";
    }

    function setStickyVisible(visible) {
      if (!stickyBar) return;
      var on = visible && isMobilePdp();
      stickyBar.classList.toggle("is-visible", on);
      document.body.classList.toggle("pdp-sticky-active", on);
      if (!on) stickyBar.style.bottom = "";
      else syncPdpStickyBottom();
    }

    function initPdpStickyReveal() {
      var trustBadges = root.querySelector(".pdp__trust-badges");
      if (!stickyBar || !trustBadges) return;

      var stickyObserver = new IntersectionObserver(
        function (entries) {
          if (!isMobilePdp()) {
            setStickyVisible(false);
            return;
          }
          var entry = entries[0];
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          setStickyVisible(passed);
        },
        { threshold: 0 }
      );

      stickyObserver.observe(trustBadges);
    }

    function slideIndexForMediaId(mediaId) {
      var slides = root.querySelectorAll(".pdp__main-slide");
      var idx = 0;
      slides.forEach(function (s, i) {
        if (String(s.getAttribute("data-media-id")) === String(mediaId)) idx = i;
      });
      return idx;
    }

    function syncThumbsToSlideIndex(idx) {
      var slides = root.querySelectorAll(".pdp__main-slide");
      var thumbs = root.querySelectorAll(".pdp__thumb");
      if (!slides[idx]) return;
      var sid = slides[idx].getAttribute("data-media-id");
      thumbs.forEach(function (t) {
        t.classList.toggle("is-active", String(t.getAttribute("data-media-id")) === String(sid));
      });
    }

    function setActiveSlide(idx, smoothScroll) {
      var inner = root.querySelector(".pdp__main-inner");
      var slides = root.querySelectorAll(".pdp__main-slide");
      if (!slides.length) return;
      idx = Math.max(0, Math.min(idx, slides.length - 1));
      syncThumbsToSlideIndex(idx);
      if (isMobilePdp()) {
        slides.forEach(function (s) {
          s.removeAttribute("hidden");
        });
        if (inner && slides[idx]) {
          inner.scrollTo({
            left: slides[idx].offsetLeft,
            behavior: smoothScroll ? "smooth" : "auto"
          });
        }
      } else {
        slides.forEach(function (s, i) {
          if (i !== idx) s.setAttribute("hidden", "");
          else s.removeAttribute("hidden");
        });
      }
      updateGalleryVideos();
    }

    function updateGalleryVideos() {
      var slides = root.querySelectorAll(".pdp__main-slide");
      if (!slides.length) return;
      var activeIdx = getCurrentSlideIndex();
      slides.forEach(function (s, i) {
        var vid = s.querySelector("video");
        if (!vid) return;
        if (i === activeIdx) {
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!vid.paused) {
          try { vid.pause(); } catch (e) {}
        }
      });
    }

    function activateMediaById(mediaId) {
      setActiveSlide(slideIndexForMediaId(mediaId), false);
    }

    function getCurrentSlideIndex() {
      var thumbs = root.querySelectorAll(".pdp__thumb");
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains("is-active")) {
          return slideIndexForMediaId(thumbs[i].getAttribute("data-media-id"));
        }
      }
      var slides = root.querySelectorAll(".pdp__main-slide");
      for (var j = 0; j < slides.length; j++) {
        if (!slides[j].hasAttribute("hidden")) return j;
      }
      return 0;
    }

    var galleryAutoTimer = null;
    var GALLERY_AUTO_MS = 15000;

    function restartGalleryAutoplay() {
      if (galleryAutoTimer) {
        clearInterval(galleryAutoTimer);
        galleryAutoTimer = null;
      }
      var slides = root.querySelectorAll(".pdp__main-slide");
      if (slides.length <= 1) return;
      if (document.hidden) return;
      galleryAutoTimer = setInterval(function () {
        var s2 = root.querySelectorAll(".pdp__main-slide");
        if (!s2.length) return;
        var cur = getCurrentSlideIndex();
        // If the active slide is a video still playing, wait — its "ended"
        // event will advance the carousel so it doesn't cut off mid-video.
        var curVid = s2[cur] && s2[cur].querySelector("video");
        if (curVid && !curVid.paused && !curVid.ended) return;
        var next = (cur + 1) % s2.length;
        setActiveSlide(next, isMobilePdp());
      }, GALLERY_AUTO_MS);
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        if (galleryAutoTimer) {
          clearInterval(galleryAutoTimer);
          galleryAutoTimer = null;
        }
      } else {
        restartGalleryAutoplay();
      }
    });

    function syncSubmitSoldForSelectedBundle() {
      function applySold(available) {
        if (soldRow) soldRow.style.display = available ? "none" : "";
        submitBtns.forEach(function (b) {
          b.disabled = !available;
        });
      }

      var radio = root.querySelector(".bundle-deal-input:checked");
      if (!radio) {
        var vNoBundle = findVariant(getSelectedFromButtons());
        var hasInventory = vNoBundle && (vNoBundle.inventoryQuantity > 0 || vNoBundle.available);
        applySold(hasInventory);
        return;
      }

      var card = radio.closest(".bundle-card");
      var cartList = variantsForBundleRadio(radio);
      var bundleProducts = parseInt(radio.getAttribute("data-bundle-qty"), 10) || 1;

      if (cartList !== variants) {
        if (!card) {
          applySold(false);
          return;
        }
        var baseSel = getSelectedFromButtonsInCard(card);
        var multiSlot =
          bundleProducts >= 2 &&
          (function () {
            for (var sm = 2; sm <= bundleProducts; sm++) {
              if (!card.querySelector('.pdp__bundle-extra-group[data-bundle-slot="' + sm + '"]')) {
                return false;
              }
            }
            return true;
          })();
        var maxSlot = multiSlot ? bundleProducts : 1;
        var allOk = true;
        for (var s = 1; s <= maxSlot; s++) {
          var vSlot = getVariantForBundleSlot(card, s, baseSel, cartList);
          if (!vSlot) {
            allOk = false;
            break;
          }
        }
        applySold(allOk);
        return;
      }

      var vMain = findVariant(getSelectedFromButtons());
      var hasInventory = vMain && (vMain.inventoryQuantity > 0 || vMain.available);
      applySold(hasInventory);
    }

    function formatCentsLikeSample(cents, sample) {
      var amount = (cents / 100).toFixed(2);
      var s = sample || "";
      if (s.indexOf("Dhs") >= 0) return "Dhs " + amount.replace(".", ",");
      if (s.indexOf("€") >= 0) return "€" + amount.replace(".", ",");
      if (s.indexOf("$") >= 0) return "$" + amount;
      if (s.indexOf("£") >= 0) return "£" + amount;
      return amount;
    }

    function applyBundlePdpPrice() {
      var card = root.querySelector(".bundle-card.is-selected:not(.bundle-card--static)");
      if (!card) {
        var vR = findVariant(getSelectedFromButtons());
        if (vR) setVariant(vR);
        syncSubmitSoldForSelectedBundle();
        return;
      }
      var v = findVariant(getSelectedFromButtons());
      var pm = v && (priceMap[String(v.id)] || priceMap[v.id]);
      var bundleSaveLabel = card.getAttribute("data-bundle-save-label") || "";
      var compareMult = parseFloat(card.getAttribute("data-bundle-compare-mult") || "0");
      var priceMult = parseFloat(card.getAttribute("data-bundle-price-mult") || "1");
      var priceDiscount = parseInt(card.getAttribute("data-bundle-price-discount") || "0", 10) || 0;
      var comparePriceMult = parseFloat(card.getAttribute("data-bundle-compare-price-mult") || "1") || 1;
      var priceText = pm && pm.price_html ? pm.price_html : card.getAttribute("data-bundle-pdp-price") || "";
      var compareText = card.getAttribute("data-bundle-pdp-compare") || "";

      if (pm && pm.price_cents) {
        var displayCents = Math.round(pm.price_cents * priceMult) - priceDiscount;
        if (displayCents < 0) displayCents = 0;
        priceText = formatCentsLikeSample(displayCents, pm.price_html || priceText);
      }

      if (pm && pm.price_cents && compareMult > 1) {
        compareText = formatCentsLikeSample(Math.round(pm.price_cents * comparePriceMult * priceMult * compareMult), pm.price_html || priceText);
      }

      if (priceText != null && String(priceText).replace(/\s/g, "").length) {
        if (priceEl) {
          priceEl.innerHTML = "";
          priceEl.textContent = priceText;
        }
        if (stickyPrice) {
          stickyPrice.innerHTML = "";
          stickyPrice.textContent = priceText;
        }
        if (compareEl) {
          if (compareText != null && String(compareText).replace(/\s/g, "").length) {
            compareEl.style.display = "";
            compareEl.innerHTML = "";
            compareEl.textContent = compareText;
          } else {
            compareEl.style.display = "none";
          }
        }
        if (bundleSaveEl) {
          var savePill = bundleSaveEl.closest(".pdp__save-pill");
          if (String(bundleSaveLabel).replace(/\s/g, "").length) {
            bundleSaveEl.textContent = bundleSaveLabel;
            if (savePill) savePill.style.display = "";
          } else if (savePill) {
            savePill.style.display = "none";
          }
        }
        if (saveEl) saveEl.style.display = "none";
      } else {
        var v0 = findVariant(getSelectedFromButtons());
        if (v0) setVariant(v0);
      }
      syncSubmitSoldForSelectedBundle();
    }

    var bundleSwatchTouched = false;

    function hasBundleDealRadios() {
      return !!root.querySelector(".bundle-deal-input");
    }

    function shouldSkipVariantGallery() {
      if (!hasBundleDealRadios()) return false;
      if (!root.querySelector(".bundle-card.is-selected:not(.bundle-card--static)")) return false;
      return !bundleSwatchTouched;
    }

    function setVariant(v) {
      if (!v || !variantInput) return;
      variantInput.value = v.id;
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url.toString());

      var pm = priceMap[String(v.id)] || priceMap[v.id];
      if (pm && priceEl) priceEl.innerHTML = pm.price_html || "";
      if (pm && compareEl) {
        if (pm.compare_html && pm.compare_html.length) {
          compareEl.style.display = "";
          compareEl.innerHTML = pm.compare_html;
        } else {
          compareEl.style.display = "none";
        }
      }
      if (pm && saveEl) {
        if (pm.save_label && pm.save_label.length) {
          saveEl.style.display = "";
          saveEl.textContent = pm.save_label;
        } else {
          saveEl.style.display = "none";
        }
      }
      syncSubmitSoldForSelectedBundle();
      if (stickyPrice && pm) {
        stickyPrice.innerHTML = pm.price_html || "";
      }

      var mid = mediaMap[String(v.id)] !== undefined ? mediaMap[String(v.id)] : mediaMap[v.id];
      if (mid && !shouldSkipVariantGallery()) activateMediaById(mid);

      restartGalleryAutoplay();
    }

    root.querySelectorAll(".pdp__thumb").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        setActiveSlide(slideIndexForMediaId(thumb.getAttribute("data-media-id")), true);
        restartGalleryAutoplay();
      });
    });

    // Gallery video sound: videos autoplay muted (browser requirement). We try
    // to enable sound by default as soon as the browser allows it (first user
    // interaction), and expose a small mute/unmute toggle on each video.
    (function () {
      var wraps = root.querySelectorAll(".pdp__main-vid-wrap[data-pdp-video]");
      if (!wraps.length) return;

      function syncBtn(wrap) {
        var vid = wrap.querySelector("video");
        var btn = wrap.querySelector("[data-pdp-mute]");
        if (!vid || !btn) return;
        var muted = vid.muted || vid.volume === 0;
        btn.classList.toggle("is-muted", muted);
        btn.setAttribute("aria-pressed", String(muted));
      }

      wraps.forEach(function (wrap) {
        var vid = wrap.querySelector("video");
        var btn = wrap.querySelector("[data-pdp-mute]");
        if (!vid || !btn) return;
        btn.addEventListener("click", function (e) {
          e.stopPropagation();
          vid.muted = !vid.muted;
          if (!vid.muted) {
            if (vid.volume === 0) vid.volume = 1;
            // Re-kick playback in case the browser paused it.
            var p = vid.play();
            if (p && p.catch) p.catch(function () {});
          }
          syncBtn(wrap);
        });
        vid.addEventListener("volumechange", function () { syncBtn(wrap); });
        // When the video finishes, advance the carousel (only if this video's
        // slide is the active one) so the autoscroll resumes from here.
        vid.addEventListener("ended", function () {
          var slides = root.querySelectorAll(".pdp__main-slide");
          if (!slides.length) return;
          var cur = getCurrentSlideIndex();
          if (slides[cur] !== wrap.closest(".pdp__main-slide")) return;
          var next = (cur + 1) % slides.length;
          setActiveSlide(next, isMobilePdp());
          restartGalleryAutoplay();
        });
      });

      var soundEnabled = false;
      function enableSoundOnce() {
        if (soundEnabled) return;
        soundEnabled = true;
        // Unmute every video, but only the currently-active slide is allowed to
        // actually play (updateGalleryVideos enforces play/pause by slide).
        wraps.forEach(function (wrap) {
          var vid = wrap.querySelector("video");
          if (!vid) return;
          vid.muted = false;
          if (vid.volume === 0) vid.volume = 1;
          syncBtn(wrap);
        });
        updateGalleryVideos();
        document.removeEventListener("pointerdown", enableSoundOnce);
        document.removeEventListener("touchstart", enableSoundOnce);
        document.removeEventListener("keydown", enableSoundOnce);
        document.removeEventListener("scroll", enableSoundOnce);
      }
      // Try immediately (works on desktop after any prior page interaction),
      // then fall back to the first explicit user gesture.
      document.addEventListener("pointerdown", enableSoundOnce, { passive: true });
      document.addEventListener("touchstart", enableSoundOnce, { passive: true });
      document.addEventListener("keydown", enableSoundOnce);
      document.addEventListener("scroll", enableSoundOnce, { passive: true });

      // Play the active slide's video (muted) on load; keep the rest paused.
      updateGalleryVideos();
    })();

    var mainInner = root.querySelector(".pdp__main-inner");
    if (mainInner) {
      var scrollSnapTimer;
      function syncDotsFromGalleryScroll() {
        if (!isMobilePdp()) return;
        var w = mainInner.clientWidth || 1;
        var idx = Math.round(mainInner.scrollLeft / w);
        var slides = root.querySelectorAll(".pdp__main-slide");
        idx = Math.max(0, Math.min(idx, slides.length - 1));
        syncThumbsToSlideIndex(idx);
        updateGalleryVideos();
      }
      mainInner.addEventListener("scroll", function () {
        if (!isMobilePdp()) return;
        clearTimeout(scrollSnapTimer);
        scrollSnapTimer = setTimeout(syncDotsFromGalleryScroll, 60);
      });
      mainInner.addEventListener("scrollend", function () {
        if (!isMobilePdp()) return;
        clearTimeout(scrollSnapTimer);
        syncDotsFromGalleryScroll();
        restartGalleryAutoplay();
      });
    }

    window.matchMedia("(max-width: 900px)").addEventListener("change", function () {
      setActiveSlide(getCurrentSlideIndex(), false);
      if (!isMobilePdp()) setStickyVisible(false);
      syncPdpStickyBottom();
    });

    initPdpStickyReveal();

    if (stickyBar && window.visualViewport) {
      syncPdpStickyBottom();
      window.visualViewport.addEventListener("resize", syncPdpStickyBottom);
      window.visualViewport.addEventListener("scroll", syncPdpStickyBottom);
    }

    root.querySelectorAll(".pdp__opt").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.classList.contains("pdp__opt--pair2") || btn.classList.contains("pdp__opt--bundle-extra")) return;
        var rawIdx = btn.getAttribute("data-option-index");
        if (rawIdx === null || rawIdx === "") return;
        var optIdx = parseInt(rawIdx, 10);
        if (isNaN(optIdx)) return;
        var val = btn.getAttribute("data-value") || "";
        var groups = root.querySelectorAll('.pdp__option-group[data-option-index="' + optIdx + '"]');
        if (!groups.length) return;
        groups.forEach(function (group) {
          group.querySelectorAll(".pdp__opt").forEach(function (b) {
            if (b.classList.contains("pdp__opt--pair2") || b.classList.contains("pdp__opt--bundle-extra")) return;
            b.classList.remove("is-selected");
          });
        });
        groups.forEach(function (group) {
          group.querySelectorAll(".pdp__opt").forEach(function (b) {
            if (b.classList.contains("pdp__opt--pair2") || b.classList.contains("pdp__opt--bundle-extra")) return;
            if ((b.getAttribute("data-value") || "") === val) b.classList.add("is-selected");
          });
        });
        var sel = getSelectedFromButtons();
        var v = findVariant(sel);
        if (btn.closest(".bundle-deals")) bundleSwatchTouched = true;
        if (v) setVariant(v);
        applyBundlePdpPrice();
      });
    });

    var cur = variants.find(function (v) {
      return String(v.id) === String(variantInput.value);
    });
    if (cur) setVariant(cur);
    restartGalleryAutoplay();

    var bundleInputs = root.querySelectorAll(".bundle-deal-input");
    var qtyInput = root.querySelector("[data-pdp-qty-input]");
    var offerInput = root.querySelector("[data-bundle-offer-input]");

    function syncBundleUi() {
      bundleInputs.forEach(function (inp) {
        var card = inp.closest(".bundle-card");
        if (card) {
          var on = inp.checked;
          card.classList.toggle("is-selected", on);
          card.querySelectorAll("button.pdp__opt, input[type='hidden']").forEach(function (el) {
            if (el.classList && el.classList.contains("bundle-deal-input")) return;
            el.disabled = !on;
          });
        }
        if (inp.checked && qtyInput) {
          var bq = inp.getAttribute("data-bundle-qty");
          if (bq != null && String(bq).length) qtyInput.value = bq;
          else {
            var cq = inp.getAttribute("data-cart-qty");
            if (cq != null && String(cq).length) qtyInput.value = cq;
          }
        }
        if (inp.checked && offerInput && inp.getAttribute("data-offer")) {
          offerInput.value = inp.getAttribute("data-offer");
        }
      });
      applyBundlePdpPrice();
    }

    bundleInputs.forEach(function (inp) {
      inp.addEventListener("change", function () {
        bundleSwatchTouched = false;
        syncBundleUi();
      });
    });
    syncBundleUi();

    root.addEventListener("click", function (e) {
      var atcBtn = e.target.closest("[data-bundle-desktop-atc]");
      if (!atcBtn || atcBtn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var card = atcBtn.closest(".bundle-card");
      if (!card) return;
      var inp = card.querySelector(".bundle-deal-input");
      if (!inp) return;
      inp.checked = true;
      inp.dispatchEvent(new Event("change", { bubbles: true }));
      syncBundleUi();
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        var ev = document.createEvent("Event");
        ev.initEvent("submit", true, true);
        form.dispatchEvent(ev);
      }
    });

    form.addEventListener("submit", function (e) {
      var selRadio = root.querySelector(".bundle-deal-input:checked");
      if (!selRadio || !qtyInput) return;

      var bundleProducts = parseInt(selRadio.getAttribute("data-bundle-qty"), 10) || 1;
      var shown = parseInt(qtyInput.value, 10) || 1;
      var bundleCount = Math.max(1, Math.round(shown / bundleProducts));

      var card = selRadio.closest(".bundle-card");

      var useMultiLineAdd =
        bundleProducts >= 2 &&
        card &&
        (function () {
          for (var s = 2; s <= bundleProducts; s++) {
            if (!card.querySelector('.pdp__bundle-extra-group[data-bundle-slot="' + s + '"]')) {
              return false;
            }
          }
          return true;
        })();

      if (!useMultiLineAdd) {
        var autoDisc = readBundleDiscountCode(selRadio);
        if (autoDisc) {
          e.preventDefault();
          var cvD = variantsForBundleRadio(selRadio);
          var cardD = selRadio.closest(".bundle-card");
          if (cardD && cvD !== variants) {
            var sD = getSelectedFromButtonsInCard(cardD);
            var vD = findVariantInList(sD, cvD, true);
            if (vD) variantInput.value = vD.id;
          }
          var qLine = String(bundleCount * bundleProducts);
          var vid = parseInt(variantInput.value, 10);
          if (!vid) {
            window.alert("Could not add to cart: invalid variant.");
            return;
          }
          var off = (offerInput && offerInput.value) || selRadio.getAttribute("data-offer") || "";
          var propsD = {};
          if (off) propsD.Offer = off;
          var pathD = cartAddJsPath(form);
          fetch(pathD, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: [{ id: vid, quantity: parseInt(qLine, 10) || 1, properties: propsD }] }),
          })
            .then(function (r) {
              return r.json().then(function (j) {
                return { ok: r.ok, j: j };
              });
            })
            .then(function (res) {
              if (!res.ok) {
                var msg =
                  (res.j && (res.j.description || res.j.message)) ||
                  (res.j && res.j.errors && String(res.j.errors)) ||
                  "";
                window.alert(msg || "Could not add to cart");
                return;
              }
              var base = (root.getAttribute("data-shop-url") || "").replace(/\/$/, "");
              var cartPath = (function () {
                try {
                  var cu = new URL(form.getAttribute("action") || "/cart/add", window.location.href);
                  return cu.pathname.replace(/\/cart\/add.*$/, "/cart") + cu.search;
                } catch (e2) {
                  return "/cart";
                }
              })();
              if (base) {
                window.location.href =
                  base +
                  "/discount/" +
                  encodeURIComponent(autoDisc) +
                  "?redirect=" +
                  encodeURIComponent(cartPath);
              } else {
                window.location.href = cartPath;
              }
            })
            .catch(function () {
              window.alert("Could not add to cart");
            });
          return;
        }
        var cv0 = variantsForBundleRadio(selRadio);
        var card0 = selRadio.closest(".bundle-card");
        if (card0 && cv0 !== variants) {
          var sfix = getSelectedFromButtonsInCard(card0);
          var vfix = findVariantInList(sfix, cv0, true);
          if (vfix) variantInput.value = vfix.id;
        }
        qtyInput.value = String(bundleCount * bundleProducts);
        return;
      }

      var cartVariants = variantsForBundleRadio(selRadio);
      var baseSel = getSelectedFromButtonsInCard(card);
      var vList = [];
      for (var s = 1; s <= bundleProducts; s++) {
        var v = getVariantForBundleSlot(card, s, baseSel, cartVariants);
        if (!v) {
          e.preventDefault();
          window.alert("Could not find a variant for pair #" + s + ". Check your selections.");
          return;
        }
        vList.push(v);
      }

      var externalOfferProduct = cartVariants !== variants;
      if (!externalOfferProduct) {
        for (var vi = 0; vi < vList.length; vi++) {
          if (!vList[vi].available) {
            e.preventDefault();
            window.alert(
              "Pair #" +
                (vi + 1) +
                " is not available for this product. Choose another option or check inventory in Shopify Admin."
            );
            return;
          }
        }
      }

      e.preventDefault();

      var offer = (offerInput && offerInput.value) || selRadio.getAttribute("data-offer") || "";

      var items = [];
      for (var p = 0; p < bundleCount; p++) {
        for (var slot = 1; slot <= bundleProducts; slot++) {
          var v = vList[slot - 1];
          var props = {};
          if (offer) props.Offer = offer;
          items.push({ id: v.id, quantity: 1, properties: props });
        }
      }

      var path = cartAddJsPath(form);
      fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          return r.json().then(function (j) {
            return { ok: r.ok, j: j };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            var msg =
              (res.j && (res.j.description || res.j.message)) ||
              (res.j && res.j.errors && String(res.j.errors)) ||
              "";
            window.alert(msg || "Could not add to cart");
            return;
          }
          var discAfter = readBundleDiscountCode(selRadio);
          var shopBase = (root.getAttribute("data-shop-url") || "").replace(/\/$/, "");
          var cartTarget = (function () {
            try {
              var cu = new URL(form.getAttribute("action") || "/cart/add", window.location.href);
              return cu.pathname.replace(/\/cart\/add.*$/, "/cart") + cu.search;
            } catch (e2) {
              return "/cart";
            }
          })();
          if (discAfter && shopBase) {
            window.location.href =
              shopBase +
              "/discount/" +
              encodeURIComponent(discAfter) +
              "?redirect=" +
              encodeURIComponent(cartTarget);
          } else {
            window.location.href = cartTarget;
          }
        })
        .catch(function () {
          window.alert("Could not add to cart");
        });
    });

    root.querySelectorAll(".pdp__opt--bundle-extra").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var slot = btn.getAttribute("data-bundle-slot");
        if (!slot) return;
        var val = btn.getAttribute("data-value") || "";
        root.querySelectorAll('.pdp__bundle-extra-group[data-bundle-slot="' + slot + '"]').forEach(function (group) {
          group.querySelectorAll(".pdp__opt--bundle-extra").forEach(function (b) {
            b.classList.toggle("is-selected", (b.getAttribute("data-value") || "") === val);
          });
        });
        bundleSwatchTouched = true;
        var sel = getSelectedFromButtons().slice();
        var oi = btn.getAttribute("data-option-index");
        if (oi != null && oi !== "") {
          var optIdx = parseInt(oi, 10);
          if (!isNaN(optIdx) && optIdx >= 0) {
            while (sel.length <= optIdx) sel.push("");
            sel[optIdx] = val;
            var vImg = findVariant(sel);
            if (vImg) {
              var mid = mediaMap[String(vImg.id)] !== undefined ? mediaMap[String(vImg.id)] : mediaMap[vImg.id];
              if (mid) activateMediaById(mid);
            }
          }
        }
        restartGalleryAutoplay();
      });
    });

    root.querySelectorAll("[data-pdp-mini-reviews]").forEach(function (wrap) {
      var viewport = wrap.querySelector(".pdp-mini-reviews__viewport");
      var slides = wrap.querySelectorAll(".pdp-mini-reviews__slide");
      var dots = wrap.querySelectorAll(".pdp-mini-reviews__dot");
      if (!viewport || !slides.length) return;

      var n = slides.length;
      var current = 0;
      var autoTimer = null;
      var scrollEndTimer = null;
      var ignoreScroll = false;
      var AUTO_MS = 30000;

      function slideW() {
        return viewport.clientWidth || 1;
      }

      function setDots(idx) {
        var i = Math.max(0, Math.min(idx, n - 1));
        dots.forEach(function (d, j) {
          d.classList.toggle("is-active", j === i);
          d.setAttribute("aria-selected", j === i ? "true" : "false");
        });
        current = i;
      }

      function scrollToIdx(idx, smooth) {
        var i = Math.max(0, Math.min(idx, n - 1));
        var x = i * slideW();
        ignoreScroll = true;
        viewport.scrollTo({ left: x, behavior: smooth ? "smooth" : "auto" });
        setDots(i);
        setTimeout(function () {
          ignoreScroll = false;
        }, smooth ? 520 : 80);
      }

      function idxFromScroll() {
        var w = slideW();
        return Math.max(0, Math.min(Math.round(viewport.scrollLeft / w), n - 1));
      }

      function restartAuto() {
        clearInterval(autoTimer);
        if (n <= 1) return;
        autoTimer = setInterval(function () {
          scrollToIdx((current + 1) % n, true);
        }, AUTO_MS);
      }

      viewport.addEventListener(
        "scroll",
        function () {
          if (ignoreScroll) return;
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(function () {
            setDots(idxFromScroll());
            restartAuto();
          }, 150);
        },
        { passive: true }
      );

      if (dots.length) {
        dots.forEach(function (d, i) {
          d.addEventListener("click", function () {
            scrollToIdx(i, true);
            restartAuto();
          });
        });
      }

      if (typeof ResizeObserver !== "undefined") {
        new ResizeObserver(function () {
          ignoreScroll = true;
          viewport.scrollTo({ left: current * slideW(), behavior: "auto" });
          setTimeout(function () {
            ignoreScroll = false;
          }, 80);
        }).observe(viewport);
      }

      setDots(0);
      viewport.scrollLeft = 0;
      restartAuto();
    });

    root.querySelectorAll("[data-pdp-ugc-carousel]").forEach(function (carousel) {
      var viewport = carousel.querySelector(".pdp-ugc__track");
      var cells = carousel.querySelectorAll(".pdp-ugc__cell");
      var nextBtn = carousel.querySelector("[data-pdp-ugc-next]");
      if (!viewport || !cells.length) return;

      var n = cells.length;
      var current = 0;
      var scrollEndTimer = null;
      var ignoreScroll = false;

      function slideW() {
        return viewport.clientWidth || 1;
      }

      function syncVideos(idx) {
        cells.forEach(function (cell, j) {
          var v = cell.querySelector("video");
          if (!v) return;
          if (j === idx) {
            v.play().catch(function () {});
          } else {
            v.pause();
          }
        });
      }

      function scrollToIdx(idx, smooth) {
        if (!isMobilePdp()) return;
        var i = Math.max(0, Math.min(idx, n - 1));
        ignoreScroll = true;
        viewport.scrollTo({ left: i * slideW(), behavior: smooth ? "smooth" : "auto" });
        current = i;
        syncVideos(i);
        setTimeout(function () {
          ignoreScroll = false;
        }, smooth ? 520 : 80);
      }

      function idxFromScroll() {
        return Math.max(0, Math.min(Math.round(viewport.scrollLeft / slideW()), n - 1));
      }

      viewport.addEventListener(
        "scroll",
        function () {
          if (!isMobilePdp() || ignoreScroll) return;
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(function () {
            var i = idxFromScroll();
            current = i;
            syncVideos(i);
          }, 120);
        },
        { passive: true }
      );

      if (nextBtn) {
        nextBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (!isMobilePdp()) return;
          if (current < n - 1) scrollToIdx(current + 1, true);
          else scrollToIdx(0, true);
        });
      }

      if (typeof ResizeObserver !== "undefined") {
        new ResizeObserver(function () {
          if (!isMobilePdp()) return;
          ignoreScroll = true;
          viewport.scrollTo({ left: current * slideW(), behavior: "auto" });
          setTimeout(function () {
            ignoreScroll = false;
          }, 80);
        }).observe(viewport);
      }

      window.matchMedia("(max-width: 900px)").addEventListener("change", function () {
        if (isMobilePdp()) {
          scrollToIdx(current, false);
        } else {
          cells.forEach(function (cell) {
            var v = cell.querySelector("video");
            if (v) v.play().catch(function () {});
          });
        }
      });

      if (isMobilePdp()) {
        scrollToIdx(0, false);
      }
    });
  });
})();
